import * as React from 'react'

import {t} from '@lib/helpers'

const CopyButton = ({text}) => {
  const [isClick, setIsClick] = React.useState(false)

  React.useEffect(() => {
    let timerId
    if (isClick) {
      timerId = window.setTimeout(() => {
        setIsClick(false)
      }, 300)
    }

    return () => {
      window.clearTimeout(timerId)
    }
  }, [isClick])

  const handleClick = (event) => {
    event.preventDefault()
    setIsClick(true)
    navigator.clipboard.writeText(text)
  }

  return (
    <button
      className='DemoDetail__button DemoDetail__button--sm'
      onClick={handleClick}
    >
      <svg viewBox='0 0 24 24' fill='currentColor'>
        <g transform='translate(-19 -8)'>
          <path
            fillRule='nonzero'
            d='M40.188 32h-12.75a2.816 2.816 0 01-2.813-2.813V16.438a2.816 2.816 0 012.813-2.812h12.75A2.816 2.816 0 0143 16.439v12.75A2.816 2.816 0 0140.187 32zm-12.75-16.5a.939.939 0 00-.938.938v12.75c0 .516.42.937.938.937h12.75c.516 0 .937-.42.937-.938V16.438a.938.938 0 00-.938-.937H27.438zm-4.688 9h-.938a.938.938 0 01-.937-.938V10.813c0-.516.42-.937.938-.937h12.75c.516 0 .937.42.937.938v.89h1.875v-.89A2.817 2.817 0 0034.562 8H21.813A2.816 2.816 0 0019 10.813v12.75a2.816 2.816 0 002.813 2.812h.937V24.5z'
          />
        </g>
      </svg>{' '}
      {isClick
        ? t('pages.demo.shared.upload_form.copied')
        : t('pages.demo.shared.upload_form.copy')}
    </button>
  )
}

export default CopyButton
